export enum FaqSection {
  TECHNICAL = "technical",
  TOP_UP = "top_up",
  STOCK = "stock",
  DELIVERY = "delivery",
  ORDER = "order",
}
